var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMaterials = function SvgMaterials(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 19",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 0a3.25 3.25 0 013.235 2.934l3.88-2.327A.75.75 0 0120 1.25v10.5a.75.75 0 01-1.136.643l-3.88-2.327A3.25 3.25 0 0111.75 13H10v.25A5.75 5.75 0 014.25 19h-3a.75.75 0 01-.75-.75v-3a.75.75 0 01.75-.75h2.594c.862 0 1.57-.659 1.649-1.5H3.25A3.25 3.25 0 010 9.75v-6.5A3.25 3.25 0 013.25 0h8.5zM8.5 13H6.996a3.156 3.156 0 01-3.152 3H2v1.5h2.25a4.25 4.25 0 004.25-4.25V13zm3.25-11.5h-8.5A1.75 1.75 0 001.5 3.25v6.5c0 .966.784 1.75 1.75 1.75h8.5a1.75 1.75 0 001.75-1.75v-6.5a1.75 1.75 0 00-1.75-1.75zm6.75 1.075l-3.5 2.1v3.65l3.5 2.1v-7.85z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMaterials, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/materials.7d7f1da6.svg";
export { ForwardRef as ReactComponent };